
import React from 'react';
import { Routes, Route, useLocation } from 'react-router';
import Layout from './components/Layout';
import Home from './pages/Home';
import EAIPPage from './pages/EAIP';
import SMSPage from './pages/SMS';
import SmsFeaturesPage from './pages/SmsFeatures';
import SmsAirlinesPage from './pages/SmsAirlines';
import LMSPage from './pages/LMS';
import PansOpsPage from './pages/PansOps';
import CompliancePage from './pages/Compliance';
import ContactPage from './pages/Contact';
import PricingPage from './pages/Pricing';
import AboutPage from './pages/About';
import BlogPage from './pages/Blog';
import BlogPostPage from './pages/BlogPost';
import NewsPage from './pages/News';
import NewsPostPage from './pages/NewsPost';
import PublicPortal from './pages/PublicPortal';
import TeamPage from './pages/Team';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import AIAssistantPage from './pages/AIAssistant';
import TryAIPage from './pages/TryAI';
import FlyMatePage from './pages/FlyMate';
import NotFoundPage from './pages/NotFound';
import SolutionsPage from './pages/Solutions';
import SmsRegulatoryPage from './pages/SmsRegulatory';
import LmsAviationAuthorityPage from './pages/LmsAviationAuthority';
import LmsAnspCaaPage from './pages/LmsAnspCaa';
import LmsAirlinesPage from './pages/LmsAirlines';
import LmsAviationCompaniesPage from './pages/LmsAviationCompanies';
import SafetyGovernancePage from './pages/SafetyGovernance';
import UTMPage from './pages/modules/utm';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const getTopicFromPath = (path: string) => {
  if (path === '/') return 'home';
  if (path.startsWith('/modules/sms')) return 'sms';
  if (path.startsWith('/sms-airlines')) return 'sms';
  if (path.startsWith('/modules/lms')) return 'lms';
  if (path.startsWith('/modules/eaip')) return 'eaip';
  if (path.startsWith('/modules/pans-ops')) return 'pans_ops';
  if (path.startsWith('/modules/utm')) return 'utm';
  if (path.startsWith('/modules/ai-assistant')) return 'ai_assistant';
  if (path.startsWith('/try-ai')) return 'ai_assistant';
  if (path.startsWith('/flymate')) return 'ai_assistant';
  if (path.startsWith('/sms-regulatory')) return 'sms_regulatory';
  if (path.startsWith('/lms-aviation-authority')) return 'lms_authority';
  if (path.startsWith('/lms-ansp-caa')) return 'lms_ansp_caa';
  if (path.startsWith('/lms-airlines')) return 'lms_airlines';
  if (path.startsWith('/lms-aviation-companies')) return 'lms_aviation_companies';
  if (path.startsWith('/safety-governance')) return 'safety_governance';
  if (path.startsWith('/solutions')) return 'solutions';
  if (path.startsWith('/compliance')) return 'compliance';
  if (path.startsWith('/pricing')) return 'pricing';
  if (path.startsWith('/about')) return 'about';
  if (path.startsWith('/blog')) return 'blog';
  if (path.startsWith('/news')) return 'news';
  if (path.startsWith('/team')) return 'team';
  if (path.startsWith('/public-portal')) return 'public_portal';
  if (path.startsWith('/contact')) return 'contact';
  if (path.startsWith('/privacy')) return 'privacy';
  if (path.startsWith('/terms')) return 'terms';
  if (path.startsWith('/cookies')) return 'cookies';
  return 'unknown';
};

const TrackPageView = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path: pathname,
      topic: getTopicFromPath(pathname),
    });
  }, [pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <>
      <ScrollToTop />
      <TrackPageView />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/modules/eaip" element={<EAIPPage />} />
          <Route path="/modules/sms" element={<SMSPage />} />
          <Route path="/modules/sms/features" element={<SmsFeaturesPage />} />
          <Route path="/sms-airlines" element={<SmsAirlinesPage />} />
          <Route path="/modules/lms" element={<LMSPage />} />
          <Route path="/modules/pans-ops" element={<PansOpsPage />} />
          <Route path="/modules/utm" element={<UTMPage />} />
          <Route path="/compliance" element={<CompliancePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/sms-regulatory" element={<SmsRegulatoryPage />} />
          <Route path="/lms-aviation-authority" element={<LmsAviationAuthorityPage />} />
          <Route path="/lms-ansp-caa" element={<LmsAnspCaaPage />} />
          <Route path="/lms-airlines" element={<LmsAirlinesPage />} />
          <Route path="/lms-aviation-companies" element={<LmsAviationCompaniesPage />} />
          <Route path="/safety-governance" element={<SafetyGovernancePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:slug" element={<NewsPostPage />} />
          <Route path="/modules/ai-assistant" element={<AIAssistantPage />} />
          <Route path="/try-ai" element={<TryAIPage />} />
          <Route path="/flymate" element={<FlyMatePage />} />
          <Route path="/public-portal" element={<PublicPortal />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </>
  );
};

export default App;
